export const DEFAULT_HEIGHT = 350;
